<template>
  <bean-nav-layout :menus="menusHasPermission" :item-is-active="handleMenuItemIsActive" :show-back="showBackButton"
    @back="$router.go(-1)" v-if="user.id">
    <template #logo>
      <div class="admin-logo">
        <img :src="require('@/assets/logo.jpg')" />
      </div>
    </template>
    <template #header-title>
      {{ title }}
      <portal-target name="layout-nav-title"></portal-target>
    </template>
    <template #header-content>
      <!-- <bean-lang-switcher /> -->
      <!-- <el-select v-if="roleOptions && roleOptions.length" :value="currentRoleId" @change="syncChange" class="role-select" :placeholder="choiceRole"> -->
      <!-- <el-option -->
      <!-- v-for="item in roleOptions" -->
      <!-- :key="item.value" -->
      <!-- :label="item.label" -->
      <!-- :value="item.value" -->
      <!-- /> -->
      <!-- </el-select > -->

      <!-- 通知提醒按钮 -->
      <el-button
        v-if="canReadNotifications"
        style="border: unset; color: black; position: relative; margin-right: 15px;"
        @click="handleNotificationClick"
      >
        <i class="el-icon-bell"></i>
        <span v-if="unreadNotificationsCount > 0" class="notification-badge">{{ unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount }}</span>
      </el-button>

      <el-dropdown @command="handleCommand">
        <el-button style="border: unset; color: black;"><i class="iconfont icon-menu"></i></el-button>
        <el-dropdown-menu class="nav-dropdown-menu" slot="dropdown">
          <el-dropdown-item command="handleShowProifile">{{ profile }}</el-dropdown-item>
          <el-dropdown-item command="handleLogoutMockLogin" v-if="displayLogoutMockLoginBtn">退出模拟登陆</el-dropdown-item>
          <el-dropdown-item command="handleLogout">{{ logout }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </template>
  </bean-nav-layout>
</template>

<script>
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import _ from 'lodash';
  import { abilityService } from 'beans-admin-plugin';
  import { TOKEN_STORAGE_KEY } from '@/constants';
  import { columnsExtend as orderSnapshotColumnsExtend } from '@/views/order_snapshot/columns_extend.js';

  @Component
  export default class LayoutNav extends Vue {
    @Prop({ type: Array, default: () => [] }) menus;

    user = {};
    roleOptions = [];
    currentRoleId = +localStorage.getItem('currentRoleId');
    unreadNotificationsCount = 0;
    notificationPollingInterval = null;

    get displayLogoutMockLoginBtn() {
      return !!_.get(this.user, 'current_super_user')
    }

    get title() {
      return _.get(this.$route, 'meta.title');
    }

    get profile() {
      return this.$t('model.profile')
    }

    get logout() {
      return this.$t('logout')
    }

    get choiceRole() {
      return this.$t('choiceRole')
    }

    get isSuperRole() {
      return _.get(this.user, 'current_role.role.kind') === 'super';
    }

    get showBackButton() {
      if (this.$route.name) {
        const routeArr = this.$route.name.split('.');
        return _.get(this.$route, 'meta.backBtn') !== false && routeArr.length > 1 && routeArr.pop() !== 'index';
      }
      return false;
    }

    get menusHasPermission() {
      const router = this.$router;
      function mapMenu(arr) {
        return arr.map(item => {
          if (item.children && item.children.length) {
            return {
              ...item,
              children: mapMenu(item.children)
            };
          }
          const { route } = router.resolve(item.route);
          const [subject] = route.name.split('.');
          const can = item.can || `${subject}.read`;
          return {
            ...item,
            can: can ? abilityService.can(can) : abilityService.routeNameCan(route.name)
          }
        });
      }
      function filterMenu(arr) {
        return arr.filter(item => {
          if (item.children && item.children.length) {
            item.children = filterMenu(item.children);
            return item.children.length;
          }
          return item.can;
        });
      }
      const menus = filterMenu(mapMenu(this.menus));
      return menus;
    }

    async mounted() {
      const that = this
      const [user, { abilities }, orderSnapshots] = await Promise.all([
        this.$request.get('/mine'),
        this.$request.get('/admin_users/abilities'),
        this.$request.post('/mine/generate_order_snapshots')
      ]);
      abilityService.rules = abilities;
      this.$root.user = user;
      this.user = user;
      if (this.$route.meta.auth !== false) {
        const data = await this.$request.get('/mine/roles');
        this.roleOptions = data.map(({ id, role, application }) => ({ value: id, label: `${role.name}${_.get(application, 'name') ? `(${application.name})` : ''}` }));
        this.currentRoleId = this.currentRoleId || (this.roleOptions.length ? this.roleOptions[0].value : null)
      }

      if (orderSnapshots.length !== 0) {
        const message = {
          functional: true,
          render() {
            return (
              <bean-table value={orderSnapshots} columns={orderSnapshotColumnsExtend([
                {
                  key: 'order',
                  renderCell: (h, { props: { value } }) => {
                    const click = () => {
                      that.$request.put('/order_snapshots/read', { params: { order_id: value.id } })

                      that.$router.push({ name: 'orders.show', params: { id: value.id } })
                    }
                    return (
                      <div onClick={click}>
                        <a href="javascript:;">{value.number}</a>
                      </div>
                    )
                  }
                },
                'changes_product_image',
                'changes_content'
              ])} />
            )
          }
        }

        this.$msgbox({
          title: '订单修改提醒',
          message: this.$createElement(message),
          showCancelButton: false,
          confirmButtonText: '关闭'
        });
      }

      // 开始轮询通知
      this.startNotificationPolling();
    }

    beforeDestroy() {
      this.stopNotificationPolling();
    }

    // 开始轮询通知
    startNotificationPolling() {
      if (!this.canReadNotifications) {
        return;
      }
      this.fetchNotifications();
      this.notificationPollingInterval = setInterval(() => {
        this.fetchNotifications();
      }, 60000); // 每1分钟轮询一次
    }

    // 停止轮询通知
    stopNotificationPolling() {
      if (this.notificationPollingInterval) {
        clearInterval(this.notificationPollingInterval);
        this.notificationPollingInterval = null;
      }
    }

    // 获取通知列表
    async fetchNotifications() {
      if (!this.canReadNotifications) {
        return;
      }
      try {
        const response = await this.$request.get('/notifications', {
          params: {
            is_read_eq: false,
            per_page: 1
          }
        },
        {
          $alert: false
        });

        this.unreadNotificationsCount = response.pagination.total || 0;
      } catch (error) {
        console.error('获取通知失败:', error);
      }
    }

    // 处理通知按钮点击
    handleNotificationClick() {
      if (!this.canReadNotifications) {
        return;
      }
      if (this.$route.name === 'notifications.index') {
        // 如果已经在通知页面，通过添加时间戳参数来触发刷新
        this.$router.replace({ name: 'notifications.index', query: { is_read_eq: false, _t: Date.now() } });
      } else {
        // 如果不在通知页面，跳转到通知页面
        this.$router.push({ name: 'notifications.index', query: { is_read_eq: false } });
      }
    }

    handleCommand(command) {
      if (command === 'handleLogout') {
        this.handleLogout();
      } else if (command === 'handleShowProifile') {
        this.$router.push({ name: 'profile.show' })
      } else if (command === 'handleLogoutMockLogin') {
        this.handleLogoutMockLogin();
      }
    }

    handleLogout() {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      this.$router.replace({ name: 'login' });
      localStorage.removeItem('currentRoleId');
    }

    async handleLogoutMockLogin() {
      const { user, token } = await this.$autoLoading(this.$request.post('/mine/logout_mock_login'));
      localStorage.setItem(TOKEN_STORAGE_KEY, token);
      localStorage.setItem('currentRoleId', _.get(user.current_role, 'id'));

      this.$message.success('退出模拟登陆成功');
      location.replace(this.$router.resolve({ name: 'admin_users.index' }).href)
    }

    handleMenuItemIsActive(menuItem) {
      const currentPath = this.$router.resolve(this.$route).resolved.path.split('/').filter(Boolean);
      const itemPath = this.$router.resolve(menuItem.route).resolved.path.split('/').filter(Boolean);
      return !!currentPath.find(item => itemPath.includes(item));
    }

    syncChange(value) {
      this.currentRoleId = value;
      if (this.$route.name !== 'home') {
        this.$router.push({ name: 'home' });
      }
      location.reload();
    }

    @Watch('currentRoleId', { immediate: true })
    currentRoleIdChange(value) {
      if (value) {
        localStorage.setItem('currentRoleId', value);
      } else {
        localStorage.removeItem('currentRoleId');
      }
    }

    get canReadNotifications() {
      return abilityService.can('notifications.read');
    }
  }
</script>

<style lang="scss" scoped>
  .admin-logo {
    font-size: 24px;
    font-weight: bold;
    display: flex;

    img {
      width: 130px;
    }
  }

  /deep/ .role-select {
    .el-input {
      input {
        border: 0;
        width: auto;
      }
    }
  }

  .current-user {
    margin: 0 20px 0 0;
    font-weight: bold;

    .el-button {
      font-weight: inherit;
    }
  }

  .nav-dropdown-menu {
    a, button {
      color: black;
    }
  }

  .notification-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background-color: #f56c6c;
    color: white;
    border-radius: 10px;
    padding: 2px 6px;
    font-size: 12px;
    line-height: 1;
    min-width: 18px;
    text-align: center;
  }
</style>
